import { BoxContainer, SelectLabel, TextField } from '@components/common';
import css from './index.module.scss';
import Typography from '@components/base/typography';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { IconNode } from '@components/base';
import Images from '@assets/images';
import { Warehouse } from '@pages/order/generate-bill-of-lading/bol';
import { Poc } from '@helpers/types/point-of-contact';

interface IProps {
  warehouseOptions: Warehouse[];
  customerPocOptions: Poc[];
}

const PickupAndDelivery = (props: IProps) => {
  const { warehouseOptions, customerPocOptions } = props;
  const { control } = useFormContext();

  const warehouseWatch = useWatch({
    control,
    name: 'warehouseDetails'
  });

  return (
    <BoxContainer className={css.mainWrapper} title="Pickup and Delivery">
      <div className={css.boxWrapper}>
        <div className={css.pickupAndDelivery}>
          <Typography variant="h5" className={css.pickupTitle}>
            Pickup Location
          </Typography>
          <div className={css.rowWrapper}>
            <Controller
              name="warehouseDetails"
              control={control}
              render={({ field, fieldState }) => (
                <SelectLabel
                  {...field}
                  options={warehouseOptions}
                  required
                  label="Warehouse Name"
                  getOptionLabel={(option: any) => option.warehouse_name}
                  getOptionValue={(option: any) => option.warehouse_id}
                  error={fieldState.invalid}
                  helperText={fieldState.error?.message}
                  rootClassName={css.fieldWrapper}
                />
              )}
            />
            <TextField
              disabled
              value={warehouseWatch?.address || ''}
              label="Address"
              placeholder="Jot down Address"
            />
          </div>
          <div className={css.rowWrapper}>
            <TextField
              disabled
              value={warehouseWatch?.telephone || ''}
              label="Telephone"
              placeholder="Jot down Telephone"
              rootClassName={css.fieldWrapper}
            />
            <TextField
              disabled
              value={warehouseWatch?.email || ''}
              label="Email"
              placeholder="Jot down Email"
              rootClassName={css.fieldWrapper}
            />
          </div>
          <div className={css.rowWrapper}>
            <TextField
              disabled
              value={warehouseWatch?.shipping_hours || ''}
              label="Shipping Hours"
              placeholder="Jot down Shipping Hours"
              rootClassName={css.fieldWrapper}
            />
          </div>
        </div>
        <div className={css.deliveryLocation}>
          <Typography variant="h5" className={css.pickupTitle}>
            Delivery Location
          </Typography>
          <div className={css.rowWrapper}>
            <Controller
              name="deliveryLocation.companyName"
              control={control}
              render={({ field, fieldState }) => (
                <TextField
                  {...field}
                  label="Company Name"
                  placeholder="Company Name"
                  error={fieldState.invalid}
                  disabled
                  endIcon={
                    fieldState.invalid && <IconNode src={Images.alertError} alt="Error Icon" />
                  }
                  helperText={fieldState.error?.message}
                />
              )}
            />
            <Controller
              name="deliveryLocation.email"
              control={control}
              render={({ field, fieldState }) => (
                <SelectLabel
                  {...field}
                  options={customerPocOptions}
                  required
                  label="Email"
                  getOptionLabel={(option: any) => option.email}
                  getOptionValue={(option: any) => option.user_id}
                  error={fieldState.invalid}
                  helperText={fieldState.error?.message}
                  rootClassName={css.fieldWrapper}
                />
              )}
            />
          </div>
          <div className={css.rowWrapper}>
            <Controller
              name="deliveryLocation.address"
              control={control}
              render={({ field, fieldState }) => (
                <TextField
                  {...field}
                  label="Address"
                  error={fieldState.invalid}
                  endIcon={
                    fieldState.invalid && <IconNode src={Images.alertError} alt="Error Icon" />
                  }
                  helperText={fieldState.error?.message}
                />
              )}
            />
          </div>
        </div>
      </div>
    </BoxContainer>
  );
};

export default PickupAndDelivery;
